/**
 * Condivisione del report e apertura in-app.
 *
 * Sta qui e non in una pagina perché serve in tre posti (Home, Analizzati, Mappa)
 * e perché due regressioni del 16/09/2026 sono nate proprio dall'averlo scritto in
 * un solo punto: il tasto «Condividi» era finito nelle card a stringa della mappa,
 * che il prospect non usa, e l'apertura del report puntava al file grezzo.
 */
import { creaLinkCondivisione } from './api';

/**
 * L'indirizzo da dare all'iframe del modale.
 *
 * NON è `url_report` (`/reports/<nome>.html`): quel percorso ora passa dal
 * controller protetto e per un prospect senza `prospect_view` risponde 403 col
 * paywall, che dentro l'iframe si vede come una pagina bianca. Questa è una rotta
 * autenticata sulla stessa origine, che l'iframe raggiunge con la sessione.
 */
export function urlReportInApp(immobileId) {
  return `/report-immobile/${immobileId}`;
}

/** Avviso breve in fondo allo schermo: sul telefono è dove si guarda. */
export function mostraToast(testo) {
  const vecchio = document.getElementById('rivelasta-toast');
  if (vecchio) vecchio.remove();

  const el = document.createElement('div');
  el.id = 'rivelasta-toast';
  el.textContent = testo;
  el.style.cssText = [
    'position:fixed', 'left:50%', 'transform:translateX(-50%)',
    'bottom:calc(24px + env(safe-area-inset-bottom))',
    'max-width:min(420px, calc(100vw - 32px))',
    'padding:12px 18px', 'border-radius:10px',
    'background:#16181C', 'color:#fff', 'font-size:13.5px', 'line-height:1.45',
    'text-align:center', 'z-index:2147483647',
    'box-shadow:0 8px 24px rgba(0,0,0,0.25)',
    'font-family:Geist,system-ui,-apple-system,sans-serif',
  ].join(';');
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 4000);
}

/** Copia negli appunti, con la via vecchia dove l'API non c'è. */
export async function copiaNegliAppunti(testo) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(testo);
      return;
    } catch (e) {
      // permesso negato o pagina non sicura: si ripiega sotto
    }
  }
  const ta = document.createElement('textarea');
  ta.value = testo;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
}

/**
 * Condivide il report di un immobile: share sheet nativo dove c'è, copia dove no.
 *
 * `navigator.share` esiste su iOS e Android e apre il foglio di sistema — è lì che
 * questi link si mandano, su WhatsApp. Sul desktop quasi mai: allora si copia e si
 * dice che è stato copiato, perché un tasto che non risponde sembra rotto.
 *
 * @param row  l'immobile (serve id, indirizzo, comune)
 * @param btn  il pulsante premuto, per mostrare lo stato lì dove si è cliccato
 */
export async function condividiReport(row, btn) {
  const testoOriginale = btn?.getAttribute('aria-label') || 'Condividi';
  const setStato = (t) => { if (btn) btn.setAttribute('aria-label', t); };

  if (btn) btn.disabled = true;
  setStato('Preparo il link…');

  try {
    const { url, titolo } = await creaLinkCondivisione(row.id);

    if (navigator.share) {
      try {
        await navigator.share({
          title: titolo || 'Analisi immobile',
          text: `Analisi di ${titolo || 'questo immobile'} — RivelAsta`,
          url,
        });
        mostraToast('Condiviso.');
      } catch (e) {
        // Foglio di condivisione chiuso dall'utente: non è un errore.
        if (e?.name === 'AbortError') {
          setStato(testoOriginale);
          if (btn) btn.disabled = false;
          return;
        }
        throw e;
      }
    } else {
      await copiaNegliAppunti(url);
      mostraToast('Link copiato: chi lo apre vede il report senza registrarsi.');
    }
  } catch (e) {
    mostraToast(e?.response?.data?.error || 'Non è stato possibile creare il link.');
    console.error('[condividi]', e);
  }

  setStato(testoOriginale);
  if (btn) btn.disabled = false;
}
